import OwnerPageTreeList from "containers/owner/page/OwnerPageTreeList";
import { Modal } from "react-bootstrap";
import React from "react";
import { createElementIdFactory } from "utils/elementIds";

function OwnerPageTreeModal({
    data = [],
    updateTableState,
    saveRecord,
    parentChild,
    propertyidlist,
    idList,
    show,
    onClose,
}) {
    const createId = createElementIdFactory("owner-page-tree-modal");

    return (
        <Modal id={createId("modal")} show={show} onHide={onClose} size="xl" centered>
            <Modal.Header id={createId("header")} closeButton>
                <Modal.Title>Owner Tree</Modal.Title>
            </Modal.Header>
            <Modal.Body id={createId("body")}>
                <div>Use the Owner Search in tabs of the owner screen to search and add parent companies.</div>
                <OwnerPageTreeList
                    controlType="table"
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    parentChild={parentChild}
                    propertyidlist={propertyidlist}
                    idList={idList}
                />
            </Modal.Body>
        </Modal>
    );
}
export default OwnerPageTreeModal;